import { ChangeCardInfo } from '../globals/change-card-info';
import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

export const updateCardInfo = async ({ ...cardInfo }: Partial<ChangeCardInfo>) => {
  const endpoint = ENDPOINT.CreditCard;

  const response = await apiHelper(endpoint, {
    method: 'POST',
    body: JSON.stringify({ ...cardInfo }),
  });

  const resp = await response.json();

  return response.ok ? resp : void 0;
};
